@if(isSearching || doneLoading)
{
<main class="container" [style]="!isDirectUrlToRequest && isSearching ? 'display: contents;' : ''">
    <section id="column1" npSetLayout [pageLayout]="PageLayout.Layout12">
        <div class="container" *ngIf="screenMessage !== ''">
            <p class="text-danger text-center">{{screenMessage}}</p>
        </div>

        <div class="row" *ngIf="isSearching">
            <div class="col col-12">
                @if (showTitle) {
                <h1>Workflow Request</h1>
                }

                <div class="row justify-content-center col-sm-12">
                    <p>Loading request...</p>
                </div>
                <div class="row justify-content-center col-sm-12">
                    <mat-spinner></mat-spinner>
                </div>
            </div>
        </div>

        <div class="row" *ngIf="doneLoading">
            <div class="col col-12">
                @if (showTitle) {
                <h1>Workflow Request</h1>
                }

                <div class="mt-4 mb-3">
                    <display-form [displayObject]="requestDisplayObject" [displayFields]="requestDisplayProperties"
                        class="mt-4"></display-form>
                    @if (userIsRequestApproverManager && workflowRequest.state ===
                    WorkflowRequestStates.PendingApproval){
                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
                        style="margin-top: 20px;">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                update approvers
                            </mat-panel-title>
                            <mat-panel-description>
                                expand to update approvers
                            </mat-panel-description>
                        </mat-expansion-panel-header>
                        <form class="branded">
                            <div class="row">
                                <div class="col col-12">
                                    <div class="mt-4 mb-3">
                                        <div class="row">
                                            @for (approver of workflowRequest.authorizedApprovers; track approver; let i
                                            = $index) {
                                            <div class="col-sm-6 mb-3">
                                                <mat-form-field appearance="outline" class="w-100"
                                                    subscriptSizing="dynamic">
                                                    <mat-label>{{originalApprovers[i].displayName}}</mat-label>
                                                    <input matInput [readonly]="true" formControlName="steward"
                                                        (click)="searchForPrimaryUser(originalApprovers[i], approvers[i])"
                                                        [value]="approvers[i].displayName" required>
                                                    <button mat-icon-button matSuffix
                                                        (click)="searchForPrimaryUser(originalApprovers[i], approvers[i])">
                                                        <mat-icon>person_search</mat-icon>
                                                    </button>
                                                </mat-form-field>
                                            </div>
                                            }
                                        </div>
                                        <display-http-error [message]="approverChangeErrorMessage.message"
                                            [errors]="approverChangeErrorMessage.errors"></display-http-error>
                                        <div class="col-12">
                                            <mat-form-field appearance="outline" class="w-100"
                                                matTooltip="Justification for permissions request"
                                                subscriptSizing="dynamic">
                                                <mat-label>justification</mat-label>
                                                <input matInput [formControl]="approverChangeJustification">
                                                <mat-error>Justification is required</mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div class="btn-toolbar d-flex justify-content-center pt-4 pb-4" role="toolbar">
                                            @if (!isSubmitting) {

                                            <button class="button" (click)="submitApproverUpdates()"
                                                type="submit">Submit
                                                Updates</button>

                                            }
                                            @else {
                                            <mat-spinner [diameter]="30"
                                                style="display:inline-block; margin-left: 10px; top: 10px;"></mat-spinner>
                                            }
                                        </div>
                                        <display-http-error [message]="approverChangeSubmitErrorMessage.message"
                                            [errors]="approverChangeSubmitErrorMessage.errors"></display-http-error>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </mat-expansion-panel>
                    }
                    <div *ngIf="canCancel" class="btn-toolbar d-flex justify-content-center pt-4 pb-4" role="toolbar">
                        <mat-spinner [diameter]="30" *ngIf="isCancelling"
                            style="display:inline-block; margin-left: 10px; top: 10px;"></mat-spinner>
                        <div class="btn-group mr-2" role="group" *ngIf="!isCancelling">
                            <button class="button" (click)="cancelRequest()" type="submit">cancel request</button>
                        </div>
                    </div>
                    <display-http-error [message]="cancellErrorMessage.message"
                        [errors]="cancellErrorMessage.errors"></display-http-error>
                </div>
            </div>
        </div>

        <div class="row" *ngIf="workflowRequest !== undefined" [hidden]="!doneLoading">
            <div class="col col-12">
                <h3>request details</h3>
                <div class="mt-4 mb-3">
                    <request-details-app-role-assignment [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.ApplicationRoleGrant">
                    </request-details-app-role-assignment>

                    <request-details-app-permissions-change
                        [clientAppId]="workflowRequest.requestDetails.clientObjectId"
                        [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')" *ngIf="workflowRequest.type === WorkflowRequestTypes.ApplicationPermissionChange ||
                            workflowRequest.type === WorkflowRequestTypes.ApplicationPermissionGrant">
                    </request-details-app-permissions-change>

                    <request-details-app-permission-revoke [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.ApplicationPermissionRevoke">
                    </request-details-app-permission-revoke>

                    <request-details-group-membership-change [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.GroupMembershipUpdate"></request-details-group-membership-change>

                    <request-details-app-create [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.ApplicationCreate"></request-details-app-create>
                    <request-details-application-update [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.ApplicationUpdate"></request-details-application-update>
                    <request-details-secret-create [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.SecretCreate"></request-details-secret-create>
                    <request-details-secret-delete [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.SecretDelete"></request-details-secret-delete>
                    <request-details-secret-update-permissions [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.SecretUpdatePermissions"></request-details-secret-update-permissions>
                    <request-details-mfa-reset [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.MfaReset"></request-details-mfa-reset>
                    <request-details-reactivate-secret-user [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.SecretUserEnable"></request-details-reactivate-secret-user>
                    <request-details-user-delete [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.GuestDelete 
                                    || workflowRequest.type === WorkflowRequestTypes.CocoUserDelete
                                    || workflowRequest.type === WorkflowRequestTypes.ServiceAccountDelete
                                    || workflowRequest.type === WorkflowRequestTypes.PrivilegeAccountDelete"></request-details-user-delete>
                    <request-details-guest-update [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.GuestUpdate"></request-details-guest-update>
                    <request-details-account-unlock [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.AccountUnlock"></request-details-account-unlock>
                    <request-details-service-account-update [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.ServiceAccountUpdate"></request-details-service-account-update>
                    <request-details-service-account-disable [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.ServiceAccountDisable"></request-details-service-account-disable>
                    <request-details-coco-create [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.CocoUserCreate"></request-details-coco-create>
                    <request-details-app-register-client-secret [requestData]="workflowRequest.requestDetails"
                        [successes]="workflowRequest.successes" (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.ApplicationNewClientSecret"></request-details-app-register-client-secret>
                    <request-details-app-delete-client-secret [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.ApplicationDeleteClientSecret"></request-details-app-delete-client-secret>
                    <request-details-group-create [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.GroupCreate"></request-details-group-create>
                    <request-details-group-update [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.GroupUpdate"></request-details-group-update>
                    <request-details-user-create [workflowRequestType]="workflowRequest.type"
                        [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.ServiceAccountCreate || 
                            workflowRequest.type === WorkflowRequestTypes.PrivilegeAccountCreate"></request-details-user-create>
                    <request-details-coco-update [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.CocoUserUpdate"></request-details-coco-update>

                    <request-details-mailbox-create [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.MailboxAccountCreate"></request-details-mailbox-create>
                    <request-details-guest-invite [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.GuestCreate"></request-details-guest-invite>
                    <request-details-compromised-sourcing-company-create [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.CyberEventCompromisedSourcingCompanyCreate"></request-details-compromised-sourcing-company-create>
                    <request-details-compromised-sourcing-company-close [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.CyberEventCompromisedSourcingCompanyClose"></request-details-compromised-sourcing-company-close>
                    <request-details-non-chevron-permissions-update [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.ApplicationNonChevronPermissionsUpdate"></request-details-non-chevron-permissions-update>
                    <request-details-service-account-deferment [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.ServiceAccountDeferment"></request-details-service-account-deferment>
                    <request-details-attestation-escalation [requestData]="workflowRequest.requestDetails"
                        (doneLoading)="componentLoaded($event, 'details')"
                        *ngIf="workflowRequest.type === WorkflowRequestTypes.Tier0AttestationEscalation"></request-details-attestation-escalation>
                </div>
            </div>
        </div>

        @if (workflowRequest !== undefined && doneLoading) {
        @if (workflowRequest.affectedObjects.length > 0) {
        <div class="row">
            <div class="col col-12">
                <h3>affected objects</h3>
                <download-button [class]="'float-right'" toolTip="download csv" (click)="exportToCsv()">
                </download-button>
                <generic-search-results [showHeader]="false" [showCounter]="false" [title]="''"
                    [records]="workflowRequest.affectedObjects" [displayedColumns]="affectedObjectsDisplayColumns"
                    [selectableRecords]="false" [allowLocalFilter]="true" [sortable]="true">
                </generic-search-results>
            </div>
        </div>
        }
        }

        @if(workflowRequest !== undefined && doneLoadingDetails && requestDisplayObject)
        {
        <div class="row">
            <div class="col col-12">
                <h3>approvals</h3>
                <request-details-approvals [workflowRequest]="workflowRequest" [principal]="currentUserProfile"
                    (doneLoading)="componentLoaded($event,'approvals')">
                </request-details-approvals>
            </div>
        </div>
        }
    </section>
</main>
}